import { NoneOrderTagDetailResponse } from "apis/data-contracts";
import { KOREA_REGION } from "config/constant";
import { atom } from "recoil";

export const analysisFormStepState = atom<number>({
  key: "analysisFormStepState",
  default: 0,
});

export const selectedAnalysisProvinceState = atom<keyof typeof KOREA_REGION>({
  key: "selectedAnalysisProvinceState",
  default: undefined,
});

export const selectedAnalysisCityState = atom<string | null>({
  key: "selectedAnalysisCityState",
  default: undefined,
});

export const selectedAnalysisBusinessTagState =
  atom<NoneOrderTagDetailResponse>({
    key: "selectedAnalysisBusinessTagState",
    default: undefined,
  });

export const analysisDocumentLevelState = atom<number>({
  key: "analysisDocumentLevelState",
  default: 0,
});

export const analysisDocumentApproveStatusState = atom<string | null>({
  key: "analysisDocumentApproveStatusState",
  default: undefined,
});
